import React from "react";
import FilterComponent from "./FilterComponent";

export default class AbstractSelectFilter extends FilterComponent {

}
